(function (root) {
  'use strict';
  if (root.__ebF05CartCaptureInstalled || !root.fetch) return;
  root.__ebF05CartCaptureInstalled = true;

  var VERSION = 'EBONYBAG_F04_CART_CAPTURE_SEAM_20261017_R04_EMPTY_INIT';
  var config = root.__EBONYBAG_F05_CART_RECOVERY__ || {};
  var worker = String(config.workerBase || '').replace(/\/$/, '');
  var nativeFetch = root.fetch.bind(root);
  var serial = Promise.resolve();
  var lastReadback = null;
  var lastCapture = null;
  var normalCheckoutProducer = null;
  var emptyCartInitializationAttempted = false;
  var editorExpiryKey = 'eb_f05_editor_test_expires_at_v1', editorExpiryTimer = null;
  var captureSessionKey = 'eb_f05_capture_session_v1', captureExpiryTimer = null;
  var currentSessionHint = null, sessionHintOverride = false;
  var preparedAttempts = new WeakMap(), consumedPreparedAttempts = new WeakSet();
  var qa = { capture: 'IDLE', event: 'IDLE', prepared: 'NONE', error: 'NONE' };
  var mutationPattern = /\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?cart\/(add|change|update|clear)(?:\.js)?\/?$/;
  var cartRoot = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';

  // F07 metadata preparation is private to this existing capture seam.
  // The browser hint only selects the path; server cookie/scope checks authorize it.
  var f07ObservedCapture = null, f07CheckoutPending = false, f07CheckoutUncertain = false;
  var f07ResumeForms = new WeakSet();
  var F07_ATTRIBUTE = 'eb_f07_cart_link';
  var F07_MARKER = /^v1\.[A-Za-z0-9_-]{43}\.[A-Za-z0-9_-]{43}$/;
  function f07Session() {
    var value = activeSession();
    return !!(value && ['F07_NATIVE_HANDOFF', 'F04_F07_K03_NATIVE_HANDOFF'].indexOf(value.capture_purpose) !== -1 && value.capabilities.saved_line_editor === false &&
      String(config.mode || 'TEST_PROFILE_ONLY') === 'TEST_PROFILE_ONLY');
  }
  function f07Stable(value) {
    if (Array.isArray(value)) return '[' + value.map(f07Stable).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(function (key) { return JSON.stringify(key) + ':' + f07Stable(value[key]); }).join(',') + '}';
    return JSON.stringify(value);
  }
  function f07Fingerprint(cart, omitMarker) {
    if (!cart || typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.items) || !cart.items.length ||
        !Number.isSafeInteger(cart.item_count) || cart.item_count < 1 || cart.items.some(function (line) {
          return !line || typeof line.key !== 'string' || !line.key || !Number.isSafeInteger(line.quantity) || line.quantity < 1 ||
            !line.properties || typeof line.properties !== 'object' || Array.isArray(line.properties);
        }) || cart.items.reduce(function (n, line) { return n + line.quantity; }, 0) !== cart.item_count ||
        !cart.attributes || typeof cart.attributes !== 'object' || Array.isArray(cart.attributes)) throw new Error('F07_CART_INCOMPLETE');
    var copy = Object.assign({}, cart, { attributes: Object.assign({}, cart.attributes) });
    if (omitMarker) delete copy.attributes[F07_ATTRIBUTE];
    if (Array.isArray(copy.cart_level_discount_applications)) copy.cart_level_discount_applications = copy.cart_level_discount_applications.map(function (application) {
      if (!application || typeof application !== 'object' || Array.isArray(application)) return application;
      var normalized = Object.assign({}, application); delete normalized.created_at; delete normalized.key; return normalized;
    });
    return f07Stable(copy);
  }
  function f07Metadata() {
    return { capture_context_id: contextId(), mutation_id: randomId(), client_revision: revision(),
      mutation_started_at: new Date().toISOString(), trigger_identity: {}, f07_native_link: true };
  }
  // This namespace contains only previously possessed raw Cart read secrets.
  // Cleanup is bounded and never clears or alters unrelated Owner storage.
  var F07_ORIGINAL_TOKEN_PREFIX = 'eb_f07_original_cart_token_v1:';
  function f07PruneOriginalTokens(storage, now) {
    var keys = [], limit = Math.min(storage.length, 64);
    for (var index = 0; index < limit; index++) {
      var key = storage.key(index);
      if (typeof key === 'string' && key.indexOf(F07_ORIGINAL_TOKEN_PREFIX) === 0 && F07_MARKER.test(key.slice(F07_ORIGINAL_TOKEN_PREFIX.length))) keys.push(key);
    }
    keys.forEach(function (key) {
      try { var value = JSON.parse(storage.getItem(key) || 'null'), expires = Date.parse(value && value.expires_at || '');
        if (value && typeof value.expires_at === 'string' && Number.isFinite(expires) && expires <= now) storage.removeItem(key);
      } catch (_) {} // A malformed entry is never an authority.
    });
  }
  function f07RetainOriginalCartToken(before, latest, issued, finalized) {
    // Best effort only, after the existing successful finalize/final read. Storage
    // failure must never hold or retry the ordinary Native checkout.
    try {
      var now = Date.now(), marker = latest && latest.attributes && latest.attributes[F07_ATTRIBUTE];
      if (!f07Session() || typeof before.token !== 'string' || !before.token || before.token.length > 1000 || /[\u0000-\u001f\u007f]/.test(before.token) ||
          before.token !== latest.token || !F07_MARKER.test(marker || '') || marker !== issued.marker ||
          typeof finalized.relation_expires_at !== 'string' || typeof issued.relation_expires_at !== 'string' || finalized.relation_expires_at !== issued.relation_expires_at || !f07FinalizedReuse(finalized, issued)) return;
      var expires = Date.parse(finalized.relation_expires_at);
      if (!Number.isFinite(expires) || expires <= now) return;
      var storage = root.localStorage, key = F07_ORIGINAL_TOKEN_PREFIX + marker;
      f07PruneOriginalTokens(storage, now);
      var old = JSON.parse(storage.getItem(key) || 'null'), oldExpiry = Date.parse(old && old.expires_at || '');
      // A valid earlier original secret/expiry is not replaced or extended.
      if (old && typeof old.cart_token === 'string' && old.cart_token && old.cart_token.length <= 1000 && !/[\u0000-\u001f\u007f]/.test(old.cart_token) &&
          Object.keys(old).sort().join(',') === 'cart_token,expires_at' && typeof old.expires_at === 'string' && Number.isFinite(oldExpiry) && oldExpiry > now) return;
      storage.setItem(key, JSON.stringify({ cart_token: before.token, expires_at: finalized.relation_expires_at }));
    } catch (_) {} // Native checkout remains unchanged when storage is unavailable.
  }

  function f07Projection(result) {
    var p = result && result.safe_projection;
    if (!p || typeof result.intake_receipt !== 'string' || !result.intake_receipt || !/^[A-Za-z0-9_-]{40,60}$/.test(p.cart_snapshot_id || '') || !Number.isSafeInteger(p.cart_snapshot_version) || p.cart_snapshot_version < 1 ||
        p.cart_operation_pending === true || p.cart_is_empty !== false) throw new Error('F07_CAPTURE_UNCONFIRMED');
    return p;
  }
  function f07RememberCapture(cart, result) {
    if (!f07Session()) return;
    try { f07Projection(result); f07ObservedCapture = { fingerprint: f07Fingerprint(cart), result: result }; }
    catch (_) { f07ObservedCapture = null; }
  }
  async function f07CaptureCurrent(cart) {
    var fingerprint = f07Fingerprint(cart);
    if (f07ObservedCapture && f07ObservedCapture.fingerprint === fingerprint) return f07ObservedCapture.result;
    var metadata = f07Metadata(), ticket = await begin(cart, metadata, 'readback');
    if (!ticket || !ticket.capture_ticket) throw new Error('F07_CAPTURE_UNCONFIRMED');
    var actual = await readNativeCart(); lastReadback = actual;
    metadata.readback_at = new Date().toISOString(); metadata.mutation_completed_at = metadata.readback_at;
    var saved = await capture(actual, 'readback', metadata, ticket, false);
    if (f07Fingerprint(actual) !== fingerprint) throw new Error('F07_CART_CHANGED');
    f07Projection(saved); return saved;
  }
  function f07FinalizedReuse(value, issued) {
    var now = Date.now(), start = Date.parse(value && value.issued_at || ''), done = Date.parse(value && value.finalized_at || ''),
      handshake = Date.parse(value && value.handshake_expires_at || ''), relation = Date.parse(value && value.relation_expires_at || '');
    return !!(value && issued && Number.isSafeInteger(value.finalized_version) && value.finalized_version > issued.base_version &&
      value.finalized_version <= value.current_version && Number.isFinite(start) && Number.isFinite(done) &&
      Number.isFinite(handshake) && Number.isFinite(relation) && start <= done && done < handshake && done <= now &&
      handshake <= relation && relation > now);
  }
  function f07Issued(value, projection) {
    var session = activeSession(), expires = Date.parse(value && value.handshake_expires_at || '');
    if (!value || value.ok !== true || value.attribute_name !== F07_ATTRIBUTE || !F07_MARKER.test(value.marker || '') ||
        (value.replaces_revoked_marker != null && (!F07_MARKER.test(value.replaces_revoked_marker) || value.replaces_revoked_marker === value.marker)) ||
        value.cart_snapshot_id !== projection.cart_snapshot_id || value.current_version !== projection.cart_snapshot_version ||
        !Number.isSafeInteger(value.base_version) || value.base_version < 1 || value.base_version > value.current_version ||
        (value.already_finalized === true ? value.base_version >= value.current_version : value.base_version !== value.current_version) ||
        !Number.isSafeInteger(value.selection_generation) || value.selection_generation < 1 ||
        !Number.isSafeInteger(value.marker_generation) || value.marker_generation < 1 || value.expires_at !== value.handshake_expires_at || !Number.isFinite(expires) ||
        (value.already_finalized === true ? !f07FinalizedReuse(value, value) : expires <= Date.now()) ||
        !session || expires > Date.parse(session.expires_at)) throw new Error('F07_ISSUE_UNCONFIRMED');
    return value;
  }
  function f07Finalized(value, issued, projection) {
    if (!value || value.ok !== true || value.finalized !== true || typeof value.native_binding_verified !== 'boolean' ||
        value.cart_snapshot_id !== projection.cart_snapshot_id || value.current_version !== projection.cart_snapshot_version ||
        !Number.isSafeInteger(value.finalized_version) || value.finalized_version < 1 || value.finalized_version > value.current_version ||
        value.selection_generation !== issued.selection_generation || value.marker_generation !== issued.marker_generation ||
        value.handshake_expires_at !== issued.handshake_expires_at || (issued.already_finalized === true ?
          (!f07FinalizedReuse(value, issued) || value.finalized_version !== issued.finalized_version || value.issued_at !== issued.issued_at ||
            value.finalized_at !== issued.finalized_at || value.relation_expires_at !== issued.relation_expires_at) :
          Date.parse(value.handshake_expires_at) <= Date.now())) throw new Error('F07_FINALIZE_UNCONFIRMED');
  }
  function f07DiagnosticCode(cause) {
    var allowed = ['F07_CART_INCOMPLETE', 'F07_CAPTURE_UNCONFIRMED', 'F07_CART_CHANGED', 'F07_ISSUE_UNCONFIRMED',
      'F07_MARKER_CHANGED', 'F07_EXISTING_MARKER_HOLD', 'F07_METADATA_WRITE_UNKNOWN', 'F07_METADATA_READBACK_MISMATCH',
      'F07_CAPTURE_VERSION_MISMATCH', 'F07_FINALIZE_UNCONFIRMED', 'F07_CHECKOUT_TARGET_CHANGED'];
    var message = cause && typeof cause.message === 'string' ? cause.message : '';
    if (allowed.indexOf(message) !== -1) return message;
    var parsed = errorCode(cause);
    if (['CAPTURE_TIMEOUT', 'CART_READ_FAILED', 'CART_READ_INVALID'].indexOf(parsed) !== -1) return parsed;
    var rejected = /^CAPTURE_REJECTED_(400|401|403|404|409|410|413|429|500|502|503|504)(?::([A-Z][A-Z0-9_]{0,119}))?$/.exec(parsed);
    if (rejected) {
      var server = ['F07_LINK_OFF', 'F07_LINK_SESSION_REQUIRED', 'TEST_GATE_REQUIRED', 'ORIGIN_NOT_ALLOWED',
        'CART_TOKEN_REQUIRED', 'NOT_FOUND', 'ORDER_CREATED', 'SNAPSHOT_SERVICE_ERROR', 'F07_LINK_LOCATOR_REGISTER_UNCERTAIN',
        'F07_LINK_SESSION_SCOPE_REQUIRED', 'F07_LINK_SESSION_EXPIRED', 'F07_LINK_CART_UNAVAILABLE',
        'F07_LINK_OWNER_SCOPE_MISMATCH', 'F07_LINK_CAPTURE_SCOPE_MISMATCH', 'F07_LINK_VERSION_CHANGED',
        'F07_LINK_PENDING_MARKER_REQUIRES_RESOLUTION', 'F07_LINK_REMOVE_REVOKED_MARKER_FIRST',
        'F07_LINK_EXISTING_CHECKOUT_BINDING_CONFLICT', 'F07_LINK_COMPLETE_LINES_REQUIRED',
        'F07_LINK_LINE_KEY_OR_QUANTITY_INVALID', 'F07_LINK_UNSUPPORTED_LINE_RELATION', 'F07_LINK_LINE_ID_INVALID',
        'F07_LINK_PROPERTIES_REQUIRED', 'F07_LINK_PROPERTIES_AMBIGUOUS', 'F07_LINK_EXPIRED', 'F07_LINK_HANDSHAKE_EXPIRED'];
      return 'CAPTURE_REJECTED_' + rejected[1] + ':' + (server.indexOf(rejected[2]) !== -1 ? rejected[2] : 'UNKNOWN');
    }
    return 'UNKNOWN';
  }
  function f07MetadataDiscrepancy(before, current, marker) {
    var result = { marker_matches: false, changed_fields: [] };
    try {
      result.marker_matches = !!(current && current.attributes && current.attributes[F07_ATTRIBUTE] === marker);
      var left = Object.assign({}, before, { attributes: Object.assign({}, before.attributes) });
      var right = Object.assign({}, current, { attributes: Object.assign({}, current.attributes) });
      delete left.attributes[F07_ATTRIBUTE]; delete right.attributes[F07_ATTRIBUTE];
      // Only closed top-level names may leave this helper; never values or arbitrary keys.
      var fields = ['token', 'note', 'attributes', 'original_total_price', 'total_price', 'total_discount', 'total_weight',
        'item_count', 'items', 'requires_shipping', 'currency', 'items_subtotal_price', 'cart_level_discount_applications',
        'discount_codes', 'checkout_charge_amount', 'duties_included', 'taxes_included'];
      function changed(key) {
        return Object.prototype.hasOwnProperty.call(left, key) !== Object.prototype.hasOwnProperty.call(right, key) ||
          f07Stable(left[key]) !== f07Stable(right[key]);
      }
      result.changed_fields = fields.filter(changed);
      if (Object.keys(left).concat(Object.keys(right)).some(function (key) { return fields.indexOf(key) === -1 && changed(key); })) result.changed_fields.push('OTHER');
    } catch (_) { result.changed_fields = ['UNAVAILABLE']; }
    return result;
  }
  function f07DiagnosticWarn(phase, cause, metadataDiscrepancy) {
    try {
      if (!f07Session() || !root.console || typeof root.console.warn !== 'function') return;
      var phases = ['CURRENT_READ', 'CAPTURE', 'ISSUE', 'METADATA', 'FINALIZE', 'FINAL_READ', 'CONTINUE'];
      var diagnostic = { phase: phases.indexOf(phase) !== -1 ? phase : 'UNKNOWN', code: f07DiagnosticCode(cause) };
      if (diagnostic.phase === 'METADATA' && diagnostic.code === 'F07_METADATA_READBACK_MISMATCH' && metadataDiscrepancy) {
        diagnostic.marker_matches = metadataDiscrepancy.marker_matches;
        diagnostic.changed_fields = metadataDiscrepancy.changed_fields;
      }
      root.console.warn('F07_CHECKOUT_DIAGNOSTIC', JSON.stringify(diagnostic));
    } catch (_) {} // Diagnostics cannot change the original error or checkout hold.
  }
  async function f07PrepareCheckout(onReady) {
    return ordered(async function () {
      if (!f07Session() || !enabled() || f07CheckoutUncertain) throw new Error('F07_CHECKOUT_HOLD');
      var phase = 'CURRENT_READ', metadataDiscrepancy = null;
      try {
        var before = await readNativeCart();
        var original = f07Fingerprint(before, true);
        phase = 'CAPTURE';
        var saved = await f07CaptureCurrent(before), projection = f07Projection(saved);
        phase = 'ISSUE';
        var issued = f07Issued(await workerPost('/v1/f07-cart-link/issue', { cart_token: before.token,
          expected_version: projection.cart_snapshot_version }), projection);
        phase = 'METADATA';
        var current = await readNativeCart();
        if (f07Fingerprint(current) !== f07Fingerprint(before)) throw new Error('F07_CART_CHANGED');
        if (issued.already_finalized === true) {
          if (current.attributes[F07_ATTRIBUTE] !== issued.marker) throw new Error('F07_MARKER_CHANGED');
        } else {
          // Only the server's exact revoked-marker CAS may replace one existing
          // marker; unknown/pending markers remain held and never retried.
          if ((current.attributes[F07_ATTRIBUTE] || null) !== (issued.replaces_revoked_marker || null)) throw new Error('F07_EXISTING_MARKER_HOLD');
          var metadata = f07Metadata(), ticket = await begin(current, metadata, 'update');
          if (!ticket || !ticket.capture_ticket) throw new Error('F07_CAPTURE_UNCONFIRMED');
          var attributes = {}; attributes[F07_ATTRIBUTE] = issued.marker;
          var response = await nativeFetch(cartRoot + 'cart/update.js', { method: 'POST', credentials: 'same-origin', cache: 'no-store',
            redirect: 'error', referrerPolicy: 'no-referrer', headers: { accept: 'application/json', 'content-type': 'application/json' },
            body: JSON.stringify({ attributes: attributes }) });
          if (!response.ok) throw new Error('F07_METADATA_WRITE_UNKNOWN');
          var ack = await response.json();
          if (!ack || ack.errors || Number(ack.status) >= 400) throw new Error('F07_METADATA_WRITE_UNKNOWN');
          metadata.mutation_completed_at = new Date().toISOString();
          current = await readNativeCart(); lastReadback = current;
          if (current.attributes[F07_ATTRIBUTE] !== issued.marker || f07Fingerprint(current, true) !== original) {
            metadataDiscrepancy = f07MetadataDiscrepancy(before, current, issued.marker);
            throw new Error('F07_METADATA_READBACK_MISMATCH');
          }
          metadata.readback_at = new Date().toISOString();
          saved = await capture(current, 'update', metadata, ticket, true);
          projection = f07Projection(saved);
          if (projection.cart_snapshot_id !== issued.cart_snapshot_id || projection.cart_snapshot_version <= issued.base_version) throw new Error('F07_CAPTURE_VERSION_MISMATCH');
        }
        phase = 'FINALIZE';
        var finalized = await workerPost('/v1/f07-cart-link/finalize', { cart_token: current.token, marker: issued.marker,
          expected_version: projection.cart_snapshot_version });
        f07Finalized(finalized, issued, projection);
        phase = 'FINAL_READ';
        var latest = await readNativeCart();
        if (!f07Session() || f07Fingerprint(latest) !== f07Fingerprint(current)) throw new Error('F07_CART_CHANGED');
        // Continue the original ordinary Shopify form only; this does not
        // author a Native event or assert that Klaviyo echoed the marker.
        f07RetainOriginalCartToken(before, latest, issued, finalized);
        phase = 'CONTINUE';
        onReady();
      } catch (cause) {
        f07CheckoutUncertain = true;
        f07DiagnosticWarn(phase, cause, metadataDiscrepancy);
        throw cause;
      }
    });
  }
  function f07CustomerMessage(button, message) {
    try {
      var note = button.parentNode.querySelector('[data-eb-f07-checkout-status]');
      if (!note) { note = root.document.createElement('p'); note.setAttribute('data-eb-f07-checkout-status', ''); note.setAttribute('role', 'status'); button.parentNode.appendChild(note); }
      note.textContent = message;
    } catch (_) {}
  }
  function f07CheckoutForm(event) {
    var form = event.target, button = event.submitter;
    if (!form || form.tagName !== 'FORM' || !button || button.name !== 'checkout' || button.form !== form || typeof form.requestSubmit !== 'function') return null;
    try {
      var action = new URL(form.action, root.location.origin), target = new URL(cartRoot + 'cart', root.location.origin);
      if (action.origin !== target.origin || action.pathname.replace(/\/$/, '') !== target.pathname.replace(/\/$/, '') || action.search || action.hash ||
          String(form.method).toLowerCase() !== 'post' || (form.target && form.target !== '_self')) return null;
      return { form: form, button: button, action: form.action };
    } catch (_) { return null; }
  }
  function f07CheckoutSubmit(event) {
    if (!f07Session()) return;
    var target = f07CheckoutForm(event); if (!target) return;
    if (f07ResumeForms.has(target.form)) { f07ResumeForms.delete(target.form); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (!event.isTrusted || f07CheckoutPending || f07CheckoutUncertain) return;
    f07CheckoutPending = true; target.button.disabled = true;
    f07CustomerMessage(target.button, 'Checking your current choices…');
    f07PrepareCheckout(function () {
      if (target.form.action !== target.action || !f07CheckoutForm({ target: target.form, submitter: target.button })) throw new Error('F07_CHECKOUT_TARGET_CHANGED');
      target.button.disabled = false; f07ResumeForms.add(target.form);
      try { target.form.requestSubmit(target.button); } finally { f07ResumeForms.delete(target.form); }
    }).catch(function () {
      f07CustomerMessage(target.button, 'We could not confirm your current choices. Please review your cart before continuing.');
    }).finally(function () { f07CheckoutPending = false; target.button.disabled = false; });
  }
  if (root.document) root.document.addEventListener('submit', f07CheckoutSubmit, true);

  function readStorage(key) { try { return root.localStorage.getItem(key); } catch (_) { return null; } }
  function writeStorage(key, value) { try { root.localStorage.setItem(key, value); } catch (_) {} }
  function sessionHint() {
    if (sessionHintOverride) return currentSessionHint;
    try {
      var value = JSON.parse(readStorage(captureSessionKey) || 'null');
      if (!value || typeof value !== 'object') return null;
      return value;
    } catch (_) { return null; }
  }
  function hasSessionHint() { return sessionHintOverride || readStorage(captureSessionKey) !== null; }
  function saveSessionHint(value) {
    currentSessionHint = value; sessionHintOverride = true;
    writeStorage(captureSessionKey, JSON.stringify(value));
  }
  function activeSession() {
    var value = sessionHint(), expiry = value && Date.parse(value.expires_at || '');
    return value && Number.isFinite(expiry) && expiry > Date.now() && value.capabilities &&
      value.capabilities.capture === true ? value : null;
  }
  function f04Session() {
    var value = activeSession();
    return !!(value && ['F04_NATIVE_HANDOFF', 'F04_F07_K03_NATIVE_HANDOFF'].indexOf(value.capture_purpose) !== -1 && value.capabilities.saved_line_editor === false);
  }
  function errorCode(error) {
    var value = String(error && error.message || '');
    if (error && error.name === 'AbortError') return 'CAPTURE_TIMEOUT';
    if (['CART_READ_FAILED', 'CART_READ_INVALID'].indexOf(value) !== -1) return value;
    if (/^CAPTURE_REJECTED_(400|401|403|404|409|410|413|429|500|502|503|504)(?::[A-Z][A-Z0-9_]{0,119})?$/.test(value)) return value;
    return 'CAPTURE_UNAVAILABLE';
  }
  // BEGIN bounded bootstrap failure observation; this grants no authority.
  var bootstrapObservationPending = false, bootstrapExistingF07Retained = false, bootstrapRetainedFailure = 'NONE';
  // Volatile provenance for this document only; never a session/grant authority.
  var bootstrapPageRequest = { made: false, ticket_shape: 'INVALID', phase: 'NOT_REQUESTED', started_at: null, error: 'NONE' };
  var bootstrapFailureCodes = ['CAPTURE_TIMEOUT', 'TEST_TICKET_INVALID_OR_USED',
    'INVALID_TEST_SESSION_EXPIRY', 'INVALID_TEST_SESSION_CAPABILITIES', 'RESPONSE_PARSE_FAILED', 'NETWORK_OR_UNKNOWN'];
  function bootstrapFailureCode(cause) {
    try {
      if (cause && (cause.name === 'AbortError' || cause.name === 'TimeoutError')) return 'CAPTURE_TIMEOUT';
      var message = String(cause && cause.message || '');
      if (/^CAPTURE_REJECTED_(400|401|403|404|409|410|413|429|500|502|503|504):TEST_TICKET_INVALID_OR_USED$/.test(message)) return 'TEST_TICKET_INVALID_OR_USED';
      if (message === 'INVALID_TEST_SESSION_EXPIRY' || message === 'INVALID_TEST_SESSION_CAPABILITIES') return message;
      if (cause && cause.name === 'SyntaxError') return 'RESPONSE_PARSE_FAILED';
    } catch (_) {}
    return 'NETWORK_OR_UNKNOWN';
  }
  function storedBootstrapFailureCode() {
    var hint = sessionHint(), code = hint && hint.bootstrap_failure_code;
    return bootstrapFailureCodes.indexOf(code) !== -1 ? code : 'NONE';
  }
  function localBootstrapObservationCode() {
    if (bootstrapObservationPending) return 'LOCAL_BOOTSTRAP_PENDING';
    if (bootstrapExistingF07Retained && f07Session()) return 'LOCAL_F07_SESSION_RETAINED';
    if (f07Session()) return 'LOCAL_F07_SESSION_READY';
    var failure = storedBootstrapFailureCode();
    return failure === 'NONE' ? 'NOT_ACTIVE' : failure;
  }
  function renderBootstrapFailureCode() {
    try {
      var doc = root.document, url = new URL(root.location.href), entries = Array.from(url.searchParams.entries());
      var diagnostic = url.searchParams.getAll('eb_f07_bootstrap_diagnostic'), qaOpen = url.searchParams.getAll('eb_f07_qa_open');
      var opted = String(config.mode || 'TEST_PROFILE_ONLY') === 'TEST_PROFILE_ONLY' &&
        url.origin === 'https://ebonybag.com' && url.pathname === '/cart' && !url.hash &&
        diagnostic.length === 1 && diagnostic[0] === '1' && qaOpen.length <= 1 &&
        (qaOpen.length === 0 || /^K06R[0-9]{1,6}$/.test(qaOpen[0])) && entries.length === 1 + qaOpen.length;
      var panel = doc && doc.getElementById('eb-f07-bootstrap-diagnostic'), code = localBootstrapObservationCode();
      if (!opted) { if (panel) panel.remove(); return; }
      if (!doc || !doc.body) return;
      if (!panel) {
        panel = doc.createElement('section'); panel.id = 'eb-f07-bootstrap-diagnostic'; panel.setAttribute('role', 'status');
        panel.style.cssText = 'margin:12px;padding:12px;border:2px solid #333;background:#fff;color:#111;font:14px/1.4 sans-serif;overflow-wrap:anywhere';
        doc.body.insertBefore(panel, doc.body.firstChild);
      }
      panel.setAttribute('data-bootstrap-failure-code', code);
      panel.setAttribute('data-current-page-request-made', String(bootstrapPageRequest.made));
      panel.setAttribute('data-ticket-shape', bootstrapPageRequest.ticket_shape);
      panel.setAttribute('data-request-phase', bootstrapPageRequest.phase);
      panel.setAttribute('data-request-started-at', bootstrapPageRequest.started_at || 'NONE');
      panel.setAttribute('data-request-error', bootstrapPageRequest.error);
      panel.textContent = 'Local QA activation: ' + code + '. ' +
        (code === 'NOT_ACTIVE' ? 'No bootstrap failure code recorded. ' : code === 'LOCAL_F07_SESSION_RETAINED' ?
          'Incoming activation failed: ' + bootstrapRetainedFailure + '. Existing local F07 session hint retained; this does not confirm the incoming activation. ' : '') +
        'CURRENT_PAGE_REQUEST_MADE:' + String(bootstrapPageRequest.made) + ' TICKET_SHAPE:' + bootstrapPageRequest.ticket_shape +
        ' REQUEST_PHASE:' + bootstrapPageRequest.phase + ' STARTED_AT:' + (bootstrapPageRequest.started_at || 'NONE') + ' REQUEST_ERROR:' + bootstrapPageRequest.error + '. ' +
        'This does not verify Gmail or checkout. No automatic retry was made.';
    } catch (_) {} // Observation cannot affect activation or native shopping.
  }
  // END bounded bootstrap failure observation.
  function renderCaptureStatus() {
    try {
    var doc = root.document;
    if (!doc || !doc.body) return;
    if (f07Session()) { ['eb-f05-capture-status', 'eb-f04-capture-status'].forEach(function (id) { var old = doc.getElementById(id); if (old) old.remove(); }); return; }
    var isF04 = f04Session(), active = activeSession();
    var isF05 = !isF04 && enabled() && (!businessCaptureEnabled() || Boolean(active));
    var panelId = isF05 ? 'eb-f05-capture-status' : 'eb-f04-capture-status';
    var panel = doc.getElementById(panelId), other = doc.getElementById(isF05 ? 'eb-f04-capture-status' : 'eb-f05-capture-status');
    if (other) other.remove();
    if ((!isF04 && !isF05) || !enabled() || String(config.mode || 'TEST_PROFILE_ONLY') !== 'TEST_PROFILE_ONLY') { if (panel) panel.remove(); return; }
    if (!panel) {
      panel = doc.createElement('div'); panel.id = panelId;
      panel.setAttribute('role', 'status'); panel.setAttribute('aria-live', 'polite');
      panel.style.cssText = 'padding:8px 12px;font:13px/1.5 sans-serif;border:1px solid #999;background:#fff;color:#222;';
      doc.body.appendChild(panel);
    }
    var state = qa.capture === 'SAVED' ? 'capture-saved' : qa.capture === 'UNAVAILABLE' ? 'capture-error' :
      ['BEGIN_PENDING', 'COMMIT_PENDING', 'READBACK_PENDING'].indexOf(qa.capture) !== -1 ? 'capture-saving' : 'session-ready';
    panel.setAttribute('data-eb-f04-capture-status', state);
    panel.setAttribute('data-editor-enabled', isF05 && editorEnabled() ? 'true' : 'false');
    panel.setAttribute('data-event-status', qa.event);
    panel.setAttribute('data-capture-error', qa.error);
    panel.setAttribute('data-prepared-status', qa.prepared);
    var label = { 'session-ready': 'Session ready', 'capture-saving': 'Saving cart', 'capture-saved': 'Cart snapshot saved', 'capture-error': 'Cart snapshot unconfirmed' };
    panel.textContent = isF04 ? 'F04 capture test: ' + label[state] + '. Saved-line editor off. ' +
      (qa.error === 'NONE' ? '' : 'Status: ' + qa.error + '. ') +
      'Owner binding and draft revision require independent verification.' :
      'Cart test: ' + label[state] + '. Event: ' + qa.event + '. Editor: ' + (editorEnabled() ? 'on' : 'off') + '. ' +
      (qa.error === 'NONE' ? '' : 'Status: ' + qa.error + '.');
    } catch (_) { /* Diagnostic presentation must never change native shopping. */ }
  }
  function setStatus(field, value) { qa[field] = value; renderCaptureStatus(); }
  function captureSessionChanged() {
    clearTimeout(captureExpiryTimer); renderCaptureStatus(); renderBootstrapFailureCode();
    var value = activeSession(), remaining = value && Date.parse(value.expires_at) - Date.now();
    if (remaining > 0) captureExpiryTimer = setTimeout(captureSessionChanged, Math.min(remaining + 10, 2147483647));
  }
  function status() {
    var mode = String(config.mode || 'TEST_PROFILE_ONLY'), hint = sessionHint(), active = activeSession();
    return { version: VERSION, capture_gate: mode === 'OFF' || !worker ? 'OFF' : mode === 'LIVE' ? 'LIVE' : businessCaptureEnabled()&&!active ? 'BUSINESS_CAPTURE' :
      active ? 'SESSION_ACTIVE' : hint ? 'SESSION_EXPIRED_OR_INVALID' : enabled() ? 'LEGACY_TEST_FLAG' : 'DISABLED',
      capture_status: qa.capture, event_status: qa.event, prepared_status: qa.prepared, error_code: qa.error,
      editor_enabled: editorEnabled() };
  }
  function randomId() {
    if (root.crypto && root.crypto.randomUUID) return root.crypto.randomUUID();
    var bytes = new Uint8Array(20); root.crypto.getRandomValues(bytes);
    return Array.from(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }
  function contextId() {
    var id = readStorage('eb_f05_capture_context_v2');
    if (!id) { id = randomId(); writeStorage('eb_f05_capture_context_v2', id); }
    return id;
  }
  function revision() {
    var value = Math.max(Number(readStorage('eb_f05_capture_revision_v2') || 0) + 1, Date.now());
    writeStorage('eb_f05_capture_revision_v2', String(value));
    return value;
  }
  // Data capture is independent of marketing dispatch, editor and F07 test rights.
  function businessCaptureEnabled(){return Boolean(worker&&config.business_capture_enabled===true&&['TEST_PROFILE_ONLY','LIVE'].indexOf(String(config.mode||'TEST_PROFILE_ONLY'))!==-1);}
  function preparedCaptureAllowed(){return f04Session()||businessCaptureEnabled()&&!activeSession();}
  function enabled() {
    if (!worker || String(config.mode || 'TEST_PROFILE_ONLY') === 'OFF') return false;
    if (businessCaptureEnabled()||String(config.mode) === 'LIVE') return true;
    // A bounded session, including an expired one, overrides the legacy switch.
    // This hint only controls attempts; every Worker call still requires its cookie.
    if (hasSessionHint()) return !!activeSession();
    try {
      if (new URL(root.location.href).searchParams.get('eb_f05_test') === '1') writeStorage('eb_f05_test', '1');
      return readStorage('eb_f05_test') === '1';
    } catch (_) { return false; }
  }
  // This nonsecret expiry is a UI release gate only. The private Worker still
  // requires its own authenticated HttpOnly cookie for every protected request.
  function editorEnabled() {
    var mode = String(config.mode || 'TEST_PROFILE_ONLY');
    if (mode === 'LIVE') return config.saved_line_editor_enabled === true;
    // Native cart editing uses this browser's legitimate cart session.
    // Public release is explicit and independent of marketing/finite QA rights.
    if (mode === 'TEST_PROFILE_ONLY' && businessCaptureEnabled() && config.saved_line_editor_enabled === true && !activeSession()) return true;
    if (mode !== 'TEST_PROFILE_ONLY') return false;
    var session = activeSession();
    if (!session || session.capture_purpose !== 'F05_CART_REVIEW' || session.capabilities.saved_line_editor !== true) return false;
    var expires = Date.parse(readStorage(editorExpiryKey) || '');
    return Number.isFinite(expires) && expires > Date.now();
  }
  function editorSessionChanged() {
    clearTimeout(editorExpiryTimer);
    root.dispatchEvent(new CustomEvent('eb:f05-editor-state-changed'));
    var remaining = Date.parse(readStorage(editorExpiryKey) || '') - Date.now();
    if (Number.isFinite(remaining) && remaining > 0) {
      editorExpiryTimer = setTimeout(editorSessionChanged, Math.min(remaining + 10, 2147483647));
    }
  }
  function marketingAllowed() {
    try { return !!(root.Shopify && root.Shopify.customerPrivacy && root.Shopify.customerPrivacy.marketingAllowed()); }
    catch (_) { return false; }
  }
  async function identified() {
    try {
      return !!(root.klaviyo && typeof root.klaviyo.isIdentified === 'function' &&
        await Promise.race([root.klaviyo.isIdentified(), new Promise(function (resolve) { setTimeout(function () { resolve(false); }, 2500); })]));
    } catch (_) { return false; }
  }
  async function readNativeCart(fetcher) {
    var response = await (fetcher || nativeFetch)(cartRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { accept: 'application/json' } });
    if (!response.ok) throw new Error('CART_READ_FAILED');
    var cart = await response.json();
    if (!cart || !Array.isArray(cart.items) || !cart.token) throw new Error('CART_READ_INVALID');
    return cart;
  }
  async function getCart(fetcher) {
    var cart = await readNativeCart(fetcher);
    if (f07Session() && !f04Session()) return cart; // Pure F07 readback never initializes/mutates an empty cart.
    if (!enabled() || cart.items.length !== 0 || emptyCartInitializationAttempted) return cart;
    // A new Shopify session can return a different provisional token on each
    // empty GET. Establish its cart cookie once, without adding items or changing
    // quantities, notes, attributes, properties, or discounts. Keep this inside
    // the existing ordered capture and re-read native state before begin.
    emptyCartInitializationAttempted = true;
    var response = await (fetcher || nativeFetch)(cartRoot + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { accept: 'application/json', 'content-type': 'application/json' },
      body: JSON.stringify({ updates: {} })
    });
    if (!response.ok) throw new Error('CART_READ_FAILED');
    return readNativeCart(fetcher);
  }
  async function workerPost(path, payload) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 5000);
    try {
      if (path === '/v1/test-session' && bootstrapObservationPending) {
        bootstrapPageRequest = { made: true, ticket_shape: /^[A-Za-z0-9_-]{43}$/.test(payload && payload.ticket || '') ? 'VALID43' : 'INVALID',
          phase: 'REQUESTED', started_at: new Date().toISOString(), error: 'NONE' };
        renderBootstrapFailureCode();
      }
      var response = await nativeFetch(worker + path, { method: 'POST', credentials: 'include', cache: 'no-store',
        referrerPolicy: 'no-referrer', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal });
      if (!response.ok) {
        // Show only a bounded machine code in the existing test-only panel.
        // No request fields, tokens, cart properties or arbitrary response text.
        var detail = null;
        try { detail = await response.json(); } catch (_) {}
        var code = detail && typeof detail.error === 'string' && /^[A-Z][A-Z0-9_]{0,119}$/.test(detail.error) ? detail.error : '';
        throw new Error('CAPTURE_REJECTED_' + response.status + (code ? ':' + code : ''));
      }
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function ordered(callback) {
    var task = function () {
      if (root.navigator.locks && typeof root.navigator.locks.request === 'function') {
        return root.navigator.locks.request('ebonybag-native-cart-v2', { mode: 'exclusive' }, callback);
      }
      return callback();
    };
    var next = serial.catch(function () {}).then(task);
    serial = next.catch(function () {});
    return next;
  }
  function preparedKey(input, init) {
    if (init && typeof init === 'object') return init;
    return init == null && root.Request && input instanceof root.Request ? input : null;
  }
  function associatePreparedAttempt(input, init, binding) {
    var key = preparedKey(input, init);
    if (!key || !preparedCaptureAllowed() || !enabled()) { setStatus('prepared', 'UNAVAILABLE'); return false; }
    // Reusing or overwriting the same request object is ambiguous, even before fetch.
    if (consumedPreparedAttempts.has(key) || preparedAttempts.has(key)) {
      preparedAttempts.delete(key); consumedPreparedAttempts.add(key);
      setStatus('prepared', 'AMBIGUOUS_REQUEST'); return false;
    }
    if (!binding || binding.schema !== 'F04_CART_PREPARED_ATTEMPT_V1' ||
        !/^pers_[a-z0-9_-]{16,100}$/i.test(binding.draft_id || '') ||
        !/^ctx_[a-z0-9_-]{16,100}$/i.test(binding.draft_context_id || '') ||
        !Number.isSafeInteger(binding.draft_revision) || binding.draft_revision < 1 ||
        !/^\d+$/.test(String(binding.product_id || '')) || !/^\d+$/.test(String(binding.variant_id || '')) ||
        !Number.isSafeInteger(binding.requested_quantity) || binding.requested_quantity < 1) {
      consumedPreparedAttempts.add(key); setStatus('prepared', 'INVALID_BINDING'); return false;
    }
    preparedAttempts.set(key, Object.freeze({ schema: binding.schema, draft_id: binding.draft_id,
      draft_revision: binding.draft_revision, draft_context_id: binding.draft_context_id,
      product_id: String(binding.product_id), variant_id: String(binding.variant_id), requested_quantity: binding.requested_quantity }));
    setStatus('prepared', 'REGISTERED'); return true;
  }
  function consumePreparedAttempt(input, init) {
    var key = preparedKey(input, init);
    if (!key || !preparedAttempts.has(key)) return null;
    var value = preparedAttempts.get(key);
    preparedAttempts.delete(key); consumedPreparedAttempts.add(key);
    if (!preparedCaptureAllowed()||!enabled()) { setStatus('prepared', 'SESSION_UNAVAILABLE'); return null; }
    setStatus('prepared', 'CONSUMED'); return value;
  }
  function snapshotRequestBody(input, init) {
    // Snapshot mutable FormData/URLSearchParams synchronously, before any await.
    var body = init && init.body;
    if (body != null) {
      if (typeof body === 'string') return { text: body };
      if ((root.FormData && body instanceof root.FormData) || (root.URLSearchParams && body instanceof root.URLSearchParams)) {
        var entries = [], valid = true;
        body.forEach(function (value, key) { if (typeof value !== 'string') valid = false; entries.push([key, value]); });
        return valid ? { entries: entries } : null;
      }
      return null;
    }
    try { return input && typeof input.clone === 'function' ? { request: input.clone() } : null; }
    catch (_) { return null; }
  }
  function plain(value) { return !!value && typeof value === 'object' && !Array.isArray(value); }
  function propertyMap(value) {
    if (value == null) return {};
    if (!plain(value)) return null;
    var out = Object.create(null), keys = Object.keys(value);
    for (var i = 0; i < keys.length; i += 1) {
      var item = value[keys[i]];
      if (item != null && ['string', 'number', 'boolean'].indexOf(typeof item) === -1) return null;
      out[keys[i]] = item;
    }
    return out;
  }
  function count(value, fallback) {
    if (value == null && fallback != null) return fallback;
    if (typeof value === 'boolean' || !/^\d+$/.test(String(value))) return null;
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  }
  function requestItem(item) {
    if (!plain(item)) return null;
    var id = String(item.id || item.variant_id || ''), quantity = count(item.quantity, 1), properties = propertyMap(item.properties);
    if (!/^\d+$/.test(id) || !quantity || !properties) return null;
    var out = { id: id, quantity: quantity, properties: properties };
    if (item.selling_plan != null && item.selling_plan !== '') {
      if (!/^\d+$/.test(String(item.selling_plan))) return null;
      out.selling_plan = String(item.selling_plan);
    }
    return out;
  }
  function formItems(entries) {
    var single = Object.create(null), indexed = Object.create(null), seen = Object.create(null), invalid = false;
    entries.forEach(function (pair) {
      var key = pair[0], value = pair[1], match = /^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/.exec(key), target, field;
      if (match) { target = indexed[match[1]] || (indexed[match[1]] = { properties: Object.create(null) }); field = match[2]; }
      else {
        match = /^items\[(\d+)\]\[properties\]\[(.+)\]$/.exec(key);
        if (match) { target = (indexed[match[1]] || (indexed[match[1]] = { properties: Object.create(null) })).properties; field = match[2]; }
        else if (/^(id|quantity|selling_plan)$/.test(key)) { target = single; field = key; }
        else { match = /^properties\[(.+)\]$/.exec(key); if (match) { target = single.properties || (single.properties = Object.create(null)); field = match[1]; } }
      }
      if (target) { if (seen[key]) invalid = true; seen[key] = true; target[field] = value; }
    });
    var indices = Object.keys(indexed).sort(function (a, b) { return Number(a) - Number(b); });
    if (invalid || (indices.length && Object.keys(single).length)) return null;
    return indices.length ? indices.map(function (key) { return indexed[key]; }) : [single];
  }
  async function preparedRequest(snapshot, binding) {
    if (!snapshot || !binding) return null;
    try {
      var items, text = snapshot.request ? await snapshot.request.text() : snapshot.text;
      if (snapshot.entries) items = formItems(snapshot.entries);
      else {
        try { var data = JSON.parse(text); items = Array.isArray(data.items) ? data.items : [data]; }
        catch (_) { var entries = []; new URLSearchParams(text).forEach(function (value, key) { entries.push([key, value]); }); items = formItems(entries); }
      }
      if (!items || !items.length) return null;
      items = items.map(requestItem);
      if (items.some(function (item) { return !item; })) return null;
      var matches = items.filter(function (item) { return item.id === binding.variant_id &&
        item.quantity === binding.requested_quantity && String(item.properties._eb_personalization_id || '') === binding.draft_id; });
      if (matches.length !== 1) return null;
      return Object.assign({}, binding, { requested_items: items });
    } catch (_) { return null; }
  }
  function planId(item) {
    var value = item && (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || item.selling_plan);
    return value == null || value === '' ? '' : String(value);
  }
  function propertyFingerprint(value) {
    var properties = propertyMap(value);
    if (!properties) return null;
    return JSON.stringify(Object.keys(properties).sort().map(function (key) { return [key, properties[key] == null ? '' : String(properties[key])]; }));
  }
  function nativeIdentity(a, b) {
    return String(a.variant_id || a.id || '') === String(b.variant_id || b.id || '') &&
      String(a.product_id || '') === String(b.product_id || '') && planId(a) === planId(b) &&
      propertyFingerprint(a.properties) !== null && propertyFingerprint(a.properties) === propertyFingerprint(b.properties);
  }
  function requestMatches(request, response) {
    var actual = propertyMap(response.properties);
    return actual && String(response.variant_id || response.id || '') === request.id && planId(request) === planId(response) &&
      Object.keys(request.properties).every(function (key) { return Object.prototype.hasOwnProperty.call(actual, key) &&
        String(actual[key] == null ? '' : actual[key]) === String(request.properties[key] == null ? '' : request.properties[key]); });
  }
  function preparedResult(attempt, body, before, after) {
    if (!attempt || !body || !before || !after || before.token !== after.token) return null;
    var returned = Array.isArray(body.items) ? body.items : [body];
    if (!returned.length || returned.some(function (item) { return !plain(item) || !item.key || !count(item.quantity); })) return null;
    var allocations = [], used = new Set(), targets = [];
    for (var i = 0; i < attempt.requested_items.length; i += 1) {
      var request = attempt.requested_items[i], matches = returned.map(function (item, index) { return requestMatches(request, item) ? index : -1; }).filter(function (index) { return index >= 0; });
      if (matches.length !== 1 || used.has(matches[0])) return null;
      used.add(matches[0]); allocations[matches[0]] = request.quantity;
      if (request.id === attempt.variant_id && String(request.properties._eb_personalization_id || '') === attempt.draft_id) targets.push(matches[0]);
    }
    if (targets.length !== 1 || String(returned[targets[0]].product_id || '') !== attempt.product_id) return null;
    var resultKeys = new Set(), beforeKeys = new Set(), afterKeys = new Set();
    for (var j = 0; j < before.items.length; j += 1) {
      var old = before.items[j], same = after.items.filter(function (item) { return item.key === old.key; });
      if (!old.key || beforeKeys.has(old.key) || !count(old.quantity) || same.length !== 1 || !nativeIdentity(old, same[0]) || Number(same[0].quantity) < Number(old.quantity)) return null;
      beforeKeys.add(old.key);
    }
    for (var k = 0; k < returned.length; k += 1) {
      var response = returned[k], line = after.items.filter(function (item) { return item.key === response.key; });
      if (resultKeys.has(response.key) || line.length !== 1 || !nativeIdentity(response, line[0])) return null;
      resultKeys.add(response.key);
      var previous = before.items.filter(function (item) { return item.key === response.key; });
      var delta = Number(line[0].quantity) - (previous.length ? Number(previous[0].quantity) : 0);
      if (delta <= 0 || (allocations[k] !== undefined && delta !== allocations[k]) ||
          (Number(response.quantity) !== delta && Number(response.quantity) !== Number(line[0].quantity))) return null;
    }
    for (var n = 0; n < after.items.length; n += 1) {
      var current = after.items[n], prior = before.items.filter(function (item) { return item.key === current.key; });
      if (!current.key || afterKeys.has(current.key) || !count(current.quantity)) return null;
      afterKeys.add(current.key);
      if (Number(current.quantity) - (prior.length ? Number(prior[0].quantity) : 0) > 0 && !resultKeys.has(current.key)) return null;
    }
    // Only native response evidence is transmitted. The Worker repeats these
    // comparisons against the request anchored at begin; it never trusts a boolean.
    return { schema: 'F04_CART_NATIVE_RESULT_V1', response_items: returned };
  }
  async function triggerFromRequest(input, init) {
    var body = init && init.body;
    if (!body && typeof input !== 'string' && input && typeof input.clone === 'function') {
      try { body = await input.clone().text(); } catch (_) {}
    }
    var values = {}, candidates = [];
    try {
      if ((root.FormData && body instanceof root.FormData) || (root.URLSearchParams && body instanceof root.URLSearchParams)) {
        body.forEach(function (value, key) { if (typeof value === 'string') values[key] = value; });
      } else if (typeof body === 'string') {
        try { var parsed = JSON.parse(body); candidates = Array.isArray(parsed.items) ? parsed.items : [parsed]; }
        catch (_) { new URLSearchParams(body).forEach(function (value, key) { values[key] = value; }); }
      }
      if (!candidates.length) candidates = [{ id: values.id, properties: {
        _eb_design_id: values['properties[_eb_design_id]'], _eb_personalization_id: values['properties[_eb_personalization_id]']
      } }];
      var item = candidates.slice().reverse().find(function (candidate) { return (candidate.properties || {})._eb_design_id; }) || candidates[0] || {};
      return { variant_id: String(item.id || item.variant_id || ''), design_id: String((item.properties || {})._eb_design_id || ''),
        personalization_id: String((item.properties || {})._eb_personalization_id || '') };
    } catch (_) { return {}; }
  }
  // Only identifiers, state, counts and timing enter analytics. Customer-entered
  // names, private properties and photograph references stay in the private store.
  function eventProjection(projection, mutation, metadata) {
    var sourceEventId = 'f05:' + projection.cart_snapshot_id + ':' + projection.cart_snapshot_version;
    var out = { producer_revision: VERSION, mutation_type: mutation, mutation_id: metadata.mutation_id,
      source_event_id: sourceEventId, $event_id: sourceEventId,
      capture_context_id: metadata.capture_context_id, mutation_completed_at: metadata.mutation_completed_at,
      readback_at: metadata.readback_at, mutation_confirmed: metadata.mutation_confirmed === true };
    ['cart_snapshot_id', 'cart_snapshot_version', 'cart_updated_at', 'cart_valid', 'cart_saved',
      'cart_is_empty', 'cart_restore_ready', 'cart_restore_reason', 'cart_line_count', 'bag_line_count',
      'bag_quantity', 'cart_bag_line_count', 'cart_bag_quantity', 'cart_continuation_ready',
      'cart_observation_status', 'cart_state', 'cart_identity_hash', 'snapshot_content_hash', 'owner_scope_id',
      'cart_has_bags', 'bag_quantity_count', 'cart_operational_line_count', 'cart_auxiliary_line_count',
      'cart_unclassified_line_count', 'cart_checkout_invalidated', 'cart_operation_pending', 'cart_source_schema', 'cart_expires_at', 'intake_receipt'].forEach(function (key) {
        if (projection[key] !== undefined) out[key] = projection[key];
      });
    return out;
  }
  async function emit(projection, mutation, metadata) {
    if (!marketingAllowed()) { setStatus('event', 'SKIPPED_CONSENT'); return; }
    if (!await identified()) { setStatus('event', 'SKIPPED_IDENTITY'); return; }
    var name = 'EBONYBAG Personalized Cart State Changed';
    var key = 'eb_f05_event_v2:' + name + ':' + projection.cart_snapshot_id + ':' + projection.cart_snapshot_version;
    try {
      if (root.sessionStorage.getItem(key)) { setStatus('event', 'ALREADY_REQUESTED'); return; }
      await root.klaviyo.track(name, eventProjection(projection, mutation, metadata));
      root.sessionStorage.setItem(key, '1');
      setStatus('event', 'TRACK_REQUESTED');
    } catch (_) { setStatus('event', 'TRACK_UNCONFIRMED'); }
  }
  async function capture(cart, mutation, metadata, ticket, confirmed, preparedNativeResult) {
    if (!ticket || !ticket.capture_ticket) { setStatus('capture', 'UNAVAILABLE'); return; }
    var operationPending = false;
    try {
      var pendingEdit = JSON.parse(readStorage('eb_f05_variant_edit_pending_v3') || 'null');
      operationPending = !!(pendingEdit && pendingEdit.token === cart.token);
    } catch (_) {}
    var payload = {
      cart: cart, mutation_type: mutation, trigger_identity: metadata.trigger_identity,
      capture_ticket: ticket.capture_ticket, capture_context_id: metadata.capture_context_id,
      mutation_id: metadata.mutation_id, client_revision: metadata.client_revision,
      mutation_started_at: metadata.mutation_started_at, mutation_completed_at: metadata.mutation_completed_at,
      readback_at: metadata.readback_at, mutation_confirmed: confirmed,
      cart_operation_pending: operationPending,
      owner_scope_id: config.ownerScopeId || null
    };
    if (mutation === 'add' && confirmed === true && ticket.f04_prepared_attempt_anchored === true && preparedNativeResult) {
      payload.f04_prepared_attempt_result = preparedNativeResult;
    }
    setStatus('capture', 'COMMIT_PENDING');
    var result = await workerPost('/v1/snapshots', payload);
    if (!result || !result.safe_projection) throw new Error('CAPTURE_UNAVAILABLE');
    lastCapture = result;
    f07RememberCapture(cart, result);
    setStatus('capture', 'SAVED');
    if (payload.f04_prepared_attempt_result) setStatus('prepared', 'RESULT_SUBMITTED_REVISION_UNVERIFIED');
    // A failed/uncertain write is reconciliation only, never an Added/Removed claim.
    metadata.mutation_confirmed = confirmed === true;
    if (!(metadata.f07_native_link === true || (f07Session() && !f04Session() && mutation === 'readback')) && (confirmed || mutation === 'readback') && result.safe_projection) await emit(Object.assign({}, result.safe_projection, { intake_receipt: result.intake_receipt }), mutation, metadata);
    if (normalCheckoutProducer) normalCheckoutProducer.rememberCapture(cart, result);
    return result;
  }
  async function begin(cart, metadata, mutation, prepared) {
    if (!enabled()) { setStatus('capture', 'NOT_ENABLED'); return null; }
    var payload = { cart_token: cart.token,
      capture_context_id: metadata.capture_context_id, mutation_id: metadata.mutation_id,
      client_revision: metadata.client_revision, mutation_type: mutation,
      mutation_started_at: metadata.mutation_started_at, owner_scope_id: config.ownerScopeId || null };
    if (mutation === 'add' && prepared && preparedCaptureAllowed()) {
      payload.f04_prepared_attempt = Object.assign({}, prepared, { before_cart: cart });
    }
    setStatus('capture', 'BEGIN_PENDING');
    var result = await workerPost('/v1/snapshots/begin', payload);
    if (prepared) setStatus('prepared', result && result.f04_prepared_attempt_anchored === true ? 'ANCHORED_DECLARATION' : 'NOT_ANCHORED');
    return result;
  }
  function cartFingerprint(cart) {
    return JSON.stringify({ token: cart.token, note: cart.note || '', attributes: cart.attributes || {}, items: cart.items.map(function (item) {
      return { key: item.key, quantity: item.quantity, properties: item.properties || {} };
    }) });
  }
  async function runMutation(mutation, trigger, operation, verify, prepared) {
    return ordered(async function () {
      var metadata = { capture_context_id: contextId(), mutation_id: randomId(), client_revision: revision(),
        mutation_started_at: new Date().toISOString(), trigger_identity: trigger || {} };
      var before = null, ticket = null;
      setStatus('error', 'NONE'); setStatus('capture', 'READBACK_PENDING');
      // Snapshot service failure must not disable Shopify shopping. An issued
      // ticket remains pending if readback fails; the scheduler must then hold.
      try { before = await getCart(); ticket = await begin(before, metadata, mutation, prepared); }
      catch (cause) { setStatus('error', errorCode(cause)); setStatus('capture', 'UNAVAILABLE'); if (prepared) setStatus('prepared', 'NOT_ANCHORED'); }
      var response, error, nativeBody = null, confirmed = false;
      try {
        response = await operation(nativeFetch, before);
        confirmed = !!(response && response.ok);
        if (confirmed) {
          try { nativeBody = await response.clone().json(); if (!nativeBody || nativeBody.errors || Number(nativeBody.status) >= 400) confirmed = false; }
          catch (_) { confirmed = false; }
        }
      } catch (cause) { error = cause; }
      metadata.mutation_completed_at = new Date().toISOString();
      try {
        var after = await getCart(); lastReadback = after;
        confirmed = typeof verify === 'function' ? await verify(before, after, confirmed) === true :
          confirmed && before !== null && cartFingerprint(before) !== cartFingerprint(after);
        metadata.readback_at = new Date().toISOString();
        var preparedNativeResult = null;
        if (prepared && ticket && ticket.f04_prepared_attempt_anchored === true) {
          try { preparedNativeResult = mutation === 'add' && confirmed ? preparedResult(prepared, nativeBody, before, after) : null; }
          catch (_) { preparedNativeResult = null; }
          if (!preparedNativeResult) setStatus('prepared', 'NATIVE_COMPARISON_UNKNOWN');
        }
        await capture(after, mutation, metadata, ticket, confirmed, preparedNativeResult);
      } catch (cause) {
        setStatus('error', errorCode(cause)); setStatus('capture', 'UNAVAILABLE');
        if (prepared) setStatus('prepared', 'CAPTURE_UNKNOWN');
        /* Preserve the native response; do not invent saved/empty. */
      }
      if (error) throw error;
      return response;
    });
  }
  async function reconcile(proofOnly) {
    return ordered(async function () {
      setStatus('error', 'NONE'); setStatus('capture', 'READBACK_PENDING');
      var metadata = { capture_context_id: contextId(), mutation_id: randomId(), client_revision: revision(),
        mutation_started_at: new Date().toISOString(), trigger_identity: {} };
      var cart, saved;
      try {
        var before = await getCart();
        var ticket = await begin(before, metadata, 'readback');
        cart = await getCart(); lastReadback = cart;
        metadata.readback_at = new Date().toISOString(); metadata.mutation_completed_at = metadata.readback_at;
        saved = await capture(cart, 'readback', metadata, ticket, false);
      } catch (cause) { setStatus('error', errorCode(cause)); setStatus('capture', 'UNAVAILABLE'); throw cause; }
      if (proofOnly) {
        if (!saved || !saved.safe_projection || !saved.intake_receipt) return null;
        var p = saved.safe_projection;
        return { cart_snapshot_id: p.cart_snapshot_id, cart_snapshot_version: p.cart_snapshot_version,
          cart_updated_at: p.cart_updated_at, cart_valid: p.cart_valid, cart_is_empty: p.cart_is_empty,
          mutation_type: 'readback', mutation_confirmed: false, intake_receipt: saved.intake_receipt,
          source_event_id: 'f05:' + p.cart_snapshot_id + ':' + p.cart_snapshot_version, cart_source_schema: p.cart_source_schema,
          cart_operation_pending: p.cart_operation_pending === true };
      }
      return cart;
    });
  }
  root.fetch = function (input, init) {
    // Consume synchronously at this exact fetch invocation, before any await.
    var preparedBinding = consumePreparedAttempt(input, init);
    var requestSnapshot = preparedBinding ? snapshotRequestBody(input, init) : null;
    var url;
    try { url = new URL(typeof input === 'string' ? input : input.url, root.location.origin); }
    catch (_) { return nativeFetch(input, init); }
    var method = String(init && init.method || input && input.method || 'GET').toUpperCase();
    var match = url.origin === root.location.origin && mutationPattern.exec(url.pathname);
    if (!match || method !== 'POST') return nativeFetch(input, init);
    // Native fetch snapshots RequestInit immediately. Our lock/begin awaits must
    // not let a caller mutate body/headers after association but before dispatch.
    // Keep the same pair for WeakMap consumption, then freeze the downstream
    // native Request synchronously; no properties or quantities are rewritten.
    var nativeInput = input, nativeInit = init;
    if (preparedBinding) {
      try {
        nativeInput = new root.Request(typeof input === 'string' ? url.href : input, init);
        nativeInit = undefined;
      } catch (_) {
        preparedBinding = null; requestSnapshot = null;
        setStatus('prepared', 'REQUEST_UNCONFIRMED');
      }
    }
    return Promise.all([triggerFromRequest(input, init), match[1] === 'add' ? preparedRequest(requestSnapshot, preparedBinding) : Promise.resolve(null)]).then(function (values) {
      if (preparedBinding && !values[1]) setStatus('prepared', 'REQUEST_UNCONFIRMED');
      return runMutation(match[1], values[0], function (fetcher) { return fetcher(nativeInput, nativeInit); }, null, values[1]);
    });
  };
  root.EBONYBAG_F05_CART_CAPTURE = {
    version: VERSION, runMutation: runMutation, withCartLock: ordered, readCart: getCart,
    editorEnabled: editorEnabled,
    associatePreparedAttempt: associatePreparedAttempt, status: status,
    refresh: function () { return reconcile(true); }, currentStateProof: function () { return reconcile(true); }, whenIdle: function () { return serial; },
    lastReadback: function () { return lastReadback; }, lastCapture: function () { return lastCapture; }
  };
  // One-use test bootstrap: the only reusable browser credential is HttpOnly.
  try {
    var fragment = new URLSearchParams(root.location.hash.slice(1));
    var testTicket = root.__EBONYBAG_F05_TEST_TICKET__ || fragment.get('eb_f05_test_ticket');
    delete root.__EBONYBAG_F05_TEST_TICKET__;
    if (testTicket) {
      fragment.delete('eb_f05_test_ticket');
      root.history.replaceState(null, '', root.location.pathname + root.location.search + (fragment.toString() ? '#' + fragment.toString() : ''));
      bootstrapObservationPending = true; renderBootstrapFailureCode();
      workerPost('/v1/test-session', { ticket: testTicket }).then(function (session) {
        var expires = Date.parse(session && session.expires_at || '');
        if (!session || session.ok !== true || session.mode !== 'TEST_PROFILE_ONLY' || !Number.isFinite(expires) || expires <= Date.now()) throw new Error('INVALID_TEST_SESSION_EXPIRY');
        if (['F04_NATIVE_HANDOFF', 'F05_CART_REVIEW', 'F07_NATIVE_HANDOFF', 'F04_F07_K03_NATIVE_HANDOFF'].indexOf(session.capture_purpose) === -1 || !session.capabilities ||
            session.capabilities.capture !== true || typeof session.capabilities.saved_line_editor !== 'boolean' ||
            (['F04_NATIVE_HANDOFF', 'F07_NATIVE_HANDOFF', 'F04_F07_K03_NATIVE_HANDOFF'].indexOf(session.capture_purpose) !== -1 && session.capabilities.saved_line_editor !== false)) throw new Error('INVALID_TEST_SESSION_CAPABILITIES');
        if (bootstrapPageRequest.made) { bootstrapPageRequest.phase = 'ACK'; bootstrapPageRequest.error = 'NONE'; }
        saveSessionHint({ capture_purpose: session.capture_purpose, expires_at: session.expires_at,
          capabilities: { capture: true, saved_line_editor: session.capabilities.saved_line_editor } });
        bootstrapObservationPending = false;
        if (session.capabilities.saved_line_editor === true) writeStorage(editorExpiryKey, session.expires_at);
        else { try { root.localStorage.removeItem(editorExpiryKey); } catch (_) {} }
        writeStorage('eb_f05_test', '1');
        setStatus('error', 'NONE'); setStatus('capture', 'SESSION_READY'); captureSessionChanged();
        editorSessionChanged();
        root.dispatchEvent(new CustomEvent('eb:f05-test-session-ready'));
      }).catch(function (cause) {
        bootstrapObservationPending = false;
        if (bootstrapPageRequest.made) { bootstrapPageRequest.phase = 'REFUSED'; bootstrapPageRequest.error = bootstrapFailureCode(cause); }
        // A failed incoming activation grants no local rights. Keep only an existing
        // F07 hint that still passes the original validator; the server cookie
        // continues to authorize every capture/checkout request independently.
        bootstrapExistingF07Retained = f07Session();
        bootstrapRetainedFailure = bootstrapExistingF07Retained ? bootstrapFailureCode(cause) : 'NONE';
        if (!bootstrapExistingF07Retained) {
          try { root.localStorage.removeItem(editorExpiryKey); } catch (_) {}
          saveSessionHint({ capture_purpose: 'INVALID', expires_at: '1970-01-01T00:00:00Z', capabilities: { capture: false, saved_line_editor: false }, bootstrap_failure_code: bootstrapFailureCode(cause) });
        }
        setStatus('error', 'SESSION_REDEMPTION_FAILED'); setStatus('capture', bootstrapExistingF07Retained ? 'SESSION_RETAINED' : 'UNAVAILABLE'); captureSessionChanged();
        editorSessionChanged();
        root.dispatchEvent(new CustomEvent('eb:f05-test-session-failed'));
      });
    }
  } catch (_) {}
  root.addEventListener('storage', function (event) {
    if (event.key === captureSessionKey) { currentSessionHint = null; sessionHintOverride = false; }
    if (event.key === editorExpiryKey || event.key === captureSessionKey) editorSessionChanged();
    if (event.key === captureSessionKey) captureSessionChanged();
  });
  if (root.document) root.document.addEventListener('DOMContentLoaded', renderCaptureStatus);
  if (root.document) root.document.addEventListener('DOMContentLoaded', renderBootstrapFailureCode);
  /* R06_ORDINARY_CHECKOUT_CLIENT_BEGIN */
/* Generated from ordinary_checkout.mjs; isolated namespace, no source mutation. */
var normalCheckoutLibrary=(function(){
/* Isolated candidate. Existing Native checkout producer, no QA/marker authority. */
const ENDPOINT='https://ebonybag-event-bridge.kanoholding.workers.dev/public/f05/cart-continue';
const RID=/^[A-Za-z0-9_-]{40,60}$/;
const EPOCH=/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function need(x,code){if(!x)throw Error(code);}
function stable(x){return Array.isArray(x)?'['+x.map(stable).join(',')+']':x&&typeof x==='object'?'{'+Object.keys(x).sort().map(k=>JSON.stringify(k)+':'+stable(x[k])).join(',')+'}':JSON.stringify(x);}
function cartFingerprint(cart){
  need(cart&&typeof cart.token==='string'&&cart.token.length>0&&Array.isArray(cart.items)&&cart.items.length>0&&Number.isSafeInteger(cart.item_count)&&cart.item_count>0&&cart.attributes&&typeof cart.attributes==='object'&&!Array.isArray(cart.attributes),'CURRENT_CART_INCOMPLETE');
  need(cart.items.every(x=>x&&typeof x.key==='string'&&x.key&&Number.isSafeInteger(x.quantity)&&x.quantity>0&&x.properties&&typeof x.properties==='object'&&!Array.isArray(x.properties))&&cart.items.reduce((n,x)=>n+x.quantity,0)===cart.item_count,'CURRENT_CART_INCOMPLETE');
  return stable(cart); // All properties, photo URLs, fees, attributes, prices, keys and token.
}
function projection(result){
  const p=result?.safe_projection;
  need(p&&RID.test(p.cart_snapshot_id??'')&&Number.isSafeInteger(p.cart_snapshot_version)&&p.cart_snapshot_version>0&&p.cart_operation_pending!==true&&p.cart_is_empty===false&&typeof result.intake_receipt==='string'&&result.intake_receipt,'CAPTURE_UNCONFIRMED');
  return p;
}

function createOrdinaryCheckoutProducer(d){
  let cached=null,pending=false,posted=false,uncertain=false;
  const now=d.clock??(()=>Date.now());
  function enabled(){return d.config.normal_checkout_continuation_enabled===true&&d.config.normal_checkout_continuation_endpoint===ENDPOINT&&d.businessCaptureEnabled()===true&&!d.activeSession();}
  function rememberCapture(cart,result){
    try{const p=projection(result);cached={fingerprint:cartFingerprint(cart),result:{safe_projection:{cart_snapshot_id:p.cart_snapshot_id,cart_snapshot_version:p.cart_snapshot_version,cart_operation_pending:p.cart_operation_pending,cart_is_empty:p.cart_is_empty},intake_receipt:result.intake_receipt}};return true;}catch(_){cached=null;return false;}
  }
  function diagnostic(code){try{d.onDiagnostic?.(code);}catch(_){} }
  async function prepare(continueOriginal,postHosted){
    need(typeof continueOriginal==='function'&&typeof postHosted==='function','TRUSTED_CONTINUATIONS_REQUIRED');
    if(posted)return {status:'HOSTED_POST_ALREADY_STARTED_NO_FALLBACK'};
    if(pending)return {status:'PREFLIGHT_ALREADY_PENDING'};
    let originalCalled=false;
    function original(){if(!originalCalled){originalCalled=true;continueOriginal();}}
    if(!enabled()||uncertain){original();return {status:'ORIGINAL_NATIVE_CHECKOUT_CONTINUED'};}
    pending=true;
    try{
      return await d.ordered(async()=>{
        try{
          need(enabled(),'BUSINESS_CAPTURE_NOT_ACTIVE');
          const before=await d.readNativeCart(),fingerprint=cartFingerprint(before);
          const result=cached?.fingerprint===fingerprint?cached.result:null;
          const previous=result?projection(result):null;
          // A fresh page must not create a readback capture or advance version.
          // The existing possession secret and exact fullcart digest let the
          // private server derive its current already-confirmed resource only.
          const digest=await d.digest(fingerprint);need(/^[a-f0-9]{64}$/.test(digest),'CURRENT_CART_DIGEST_UNAVAILABLE');
          const capability=await d.workerPost('/v1/normal-checkout-capability',{cart_token:before.token,expected_version:previous?previous.cart_snapshot_version:null,cart_fingerprint_sha256:digest});
          need(capability?.schema==='NORMAL_CHECKOUT_CONTINUATION_CAPABILITY_V1'&&capability.eligible===true&&RID.test(capability.cart_snapshot_id??'')&&Number.isSafeInteger(capability.version)&&capability.version>0&&(!previous||(capability.cart_snapshot_id===previous.cart_snapshot_id&&capability.version===previous.cart_snapshot_version))&&EPOCH.test(capability.access_epoch??'')&&typeof capability.resource_access_token==='string'&&capability.resource_access_token.length>0&&Number.isFinite(capability.expires_at_ms)&&capability.expires_at_ms>now(),'FINITE_CAPABILITY_UNAVAILABLE');
          const latest=await d.readNativeCart();need(enabled()&&cartFingerprint(latest)===fingerprint&&capability.expires_at_ms>now(),'CURRENT_CART_CHANGED');
          const fields={cart_snapshot_id:capability.cart_snapshot_id,resource_access_token:capability.resource_access_token,expected_version:String(capability.version),intent:'continue-with-these-bags'};
          // Mark before POST starts. An exception/unknown here never creates a
          // second native cart or falls through to the original Checkout form.
          postHosted(fields,ENDPOINT,()=>{posted=true;});need(posted,'HOSTED_POST_NOT_STARTED');
          return {status:'HOSTED_NATIVE_CONTINUATION_POST_STARTED'};
        }catch(error){
          uncertain=true;
          const allowed=['CURRENT_CART_INCOMPLETE','CAPTURE_UNCONFIRMED','CURRENT_CART_CHANGED','CURRENT_CART_DIGEST_UNAVAILABLE','FINITE_CAPABILITY_UNAVAILABLE','BUSINESS_CAPTURE_NOT_ACTIVE'];
          diagnostic(allowed.includes(error?.message)?error.message:posted?'HOSTED_POST_UNKNOWN_NO_FALLBACK':'TRACKING_PREFLIGHT_UNAVAILABLE');
          if(!posted){original();return {status:'ORIGINAL_NATIVE_CHECKOUT_CONTINUED'};}
          return {status:'HOSTED_POST_UNKNOWN_NO_FALLBACK'};
        }
      });
    }catch(_){uncertain=true;diagnostic(posted?'HOSTED_POST_UNKNOWN_NO_FALLBACK':'TRACKING_PREFLIGHT_UNAVAILABLE');if(!posted)original();return {status:posted?'HOSTED_POST_UNKNOWN_NO_FALLBACK':'ORIGINAL_NATIVE_CHECKOUT_CONTINUED'};}finally{pending=false;}
  }
  return {enabled,rememberCapture,prepare,status:()=>({pending,hosted_post_started:posted,tracking_preflight_uncertain:uncertain})};
}

function postTrustedContinuationForm(root,fields,endpoint,onStart){
  need(endpoint===ENDPOINT&&Object.keys(fields).sort().join(',')==='cart_snapshot_id,expected_version,intent,resource_access_token'&&fields.intent==='continue-with-these-bags','TRUSTED_HOSTED_FORM_REQUIRED');
  const form=root.document.createElement('form');form.method='POST';form.action=ENDPOINT;form.target='_self';form.hidden=true;
  for(const [name,value] of Object.entries(fields)){const input=root.document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.appendChild(input);}
  root.document.body.appendChild(form);onStart();root.HTMLFormElement.prototype.submit.call(form);
}

function installOrdinaryCheckoutSubmit(root,producer,{cartRoot='/',postHosted=(fields,url,onStart)=>postTrustedContinuationForm(root,fields,url,onStart)}={}){
  const resumed=new WeakSet();
  root.document.addEventListener('submit',event=>{
    const form=event.target,button=event.submitter;
    if(!form||form.tagName!=='FORM'||!button||button.name!=='checkout'||button.form!==form||typeof form.requestSubmit!=='function')return;
    if(resumed.has(form)){resumed.delete(form);return;}
    if(!event.isTrusted||!producer.enabled())return;
    try{const action=new URL(form.action,root.location.origin),target=new URL(cartRoot+'cart',root.location.origin);if(action.origin!==target.origin||action.pathname.replace(/\/$/,'')!==target.pathname.replace(/\/$/,'')||action.search||action.hash||String(form.method).toLowerCase()!=='post'||form.target&&form.target!=='_self')return;}catch(_){return;}
    event.preventDefault();event.stopImmediatePropagation();const originalAction=form.action;
    const original=()=>{if(form.action!==originalAction)return;button.disabled=false;resumed.add(form);try{form.requestSubmit(button);}finally{resumed.delete(form);}};
    button.disabled=true;producer.prepare(original,postHosted).finally(()=>{button.disabled=false;});
  },true);
}

return {createOrdinaryCheckoutProducer:createOrdinaryCheckoutProducer,installOrdinaryCheckoutSubmit:installOrdinaryCheckoutSubmit,cartFingerprint:cartFingerprint,postTrustedContinuationForm:postTrustedContinuationForm,ENDPOINT:ENDPOINT};
})();

  /* R06_ORDINARY_CHECKOUT_CLIENT_END */

  normalCheckoutProducer = normalCheckoutLibrary.createOrdinaryCheckoutProducer({
    config: Object.assign({}, config, { normal_checkout_continuation_enabled: true, normal_checkout_continuation_endpoint: "https://ebonybag-event-bridge.kanoholding.workers.dev/public/f05/cart-continue" }), businessCaptureEnabled: businessCaptureEnabled,
    activeSession: activeSession, readNativeCart: readNativeCart,
    begin: begin, capture: capture, workerPost: workerPost, ordered: ordered,
    digest: async function (value) {
      var bytes = await root.crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
      return Array.from(new Uint8Array(bytes)).map(function (x) { return x.toString(16).padStart(2, "0"); }).join("");
    },
    onDiagnostic: function (code) {
      if (root.console && typeof root.console.warn === 'function') root.console.warn('NORMAL_CHECKOUT_TRACKING', code);
    }
  });
  if (root.document) normalCheckoutLibrary.installOrdinaryCheckoutSubmit(root, normalCheckoutProducer, { cartRoot: cartRoot });

  captureSessionChanged();
  editorSessionChanged();
})(window);
